import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledTeleConsultationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18478_36406)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip1_18478_36406)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M17 6.90187L20.7942 5.08376C20.9212 5.02292 21.0623 4.9942 21.2042 5.00032C21.346 5.00644 21.4839 5.04721 21.6047 5.11875C21.7255 5.19029 21.8252 5.29024 21.8944 5.4091C21.9636 5.52796 21.9999 5.66179 22 5.7979V11.2011C21.9999 11.3372 21.9636 11.4711 21.8944 11.5899C21.8252 11.7088 21.7255 11.8087 21.6047 11.8803C21.4839 11.9518 21.346 11.9926 21.2042 11.9987C21.0623 12.0048 20.9212 11.9761 20.7942 11.9153L17 10.0972V6.90187Z",
							fill: "#4B7987",
							stroke: "#1F3B44",
							strokeLinecap: "round",
							strokeLinejoin: "round"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M7 4.66618C7 4.22415 7.17559 3.80023 7.48816 3.48767C7.80072 3.17511 8.22464 2.99951 8.66667 2.99951H15.3333C15.7754 2.99951 16.1993 3.17511 16.5118 3.48767C16.8244 3.80023 17 4.22415 17 4.66618V11.3328C17 11.7749 16.8244 12.1988 16.5118 12.5114C16.1993 12.8239 15.7754 12.9995 15.3333 12.9995H8.66667C8.22464 12.9995 7.80072 12.8239 7.48816 12.5114C7.17559 12.1988 7 11.7749 7 11.3328V4.66618Z",
							fill: "#4B7987",
							stroke: "#1F3B44",
							strokeLinecap: "round",
							strokeLinejoin: "round"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M5.14355 7.51172C5.45913 7.55896 5.73619 7.7433 5.9043 8.00879L5.97949 8.14844L5.98242 8.1543L7.10938 10.7793L7.11719 10.7988L7.12402 10.8184C7.14195 10.872 7.19629 11.0214 7.19629 11.1875C7.19629 11.5363 7.02542 11.837 6.80078 12.0186L6.80176 12.0195L5.67969 12.9365C6.45173 14.3835 7.6261 15.5555 9.07617 16.3262L9.99707 15.2061C10.1716 14.9911 10.4706 14.8125 10.8066 14.8125L10.9346 14.8203C10.9746 14.8253 11.0116 14.8322 11.0449 14.8398L11.1992 14.8848L11.2188 14.8916L11.2373 14.8994L13.8682 16.0244L13.8818 16.0303L13.8945 16.0371C14.2481 16.2136 14.5 16.5953 14.5 17.0234V17.1973L14.4873 17.2529L13.9238 19.6904L13.9209 19.7002L13.9189 19.71C13.7914 20.1768 13.3886 20.4999 12.8965 20.5C6.58604 20.5 1.5 15.4255 1.5 9.125C1.5 8.63206 1.82472 8.23059 2.29102 8.10352L2.30078 8.10059L2.31055 8.09863L4.75293 7.53613L4.80859 7.52344H4.82129C4.82539 7.5223 4.83016 7.52078 4.83496 7.51953C4.84613 7.51663 4.86432 7.51258 4.88574 7.50879C4.90631 7.50516 4.94051 7.5 4.98242 7.5L5.14355 7.51172Z",
							fill: "white",
							stroke: "#1F3B44"
						})
					]
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 19,
					cy: 19,
					r: 4.5,
					fill: "white",
					stroke: "#1F3B44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17 19H21",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19 17V21",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18478_36406",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_18478_36406",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgFilledTeleConsultationIcon);
const Memo = memo(ForwardRef);
export default Memo;
